module.exports = __webpack_public_path__ + "img/submit-success.9ae45614.png";